import { render, staticRenderFns } from "./practice-overview-student.vue?vue&type=template&id=5c4ee194&scoped=true"
import script from "./practice-overview-student.vue?vue&type=script&lang=js"
export * from "./practice-overview-student.vue?vue&type=script&lang=js"
import style0 from "./practice-overview-student.vue?vue&type=style&index=0&id=5c4ee194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ee194",
  null
  
)

export default component.exports